import axiosInstance from '@/utils/api.js'

var state = {
  irdetoActivate: [],
  irdetoDeactivate: [],
  irdetoPairchipset: [],
  irdetoUnpairAllChipsets: [],
  irdetoResetPIN: [],
  irdetoSynchronize: []
}

var getters = {
  IRDETO_ACTIVATE: (state) => {
    return state.irdetoActivate
  },
  IRDETO_DEACTIVATE: (state) => {
    return state.irdetoDeactivate
  },
  IRDETO_PAIR_CHIPSET: (state) => {
    return state.irdetoPairchipset
  },
  IRDETO_UNPAIR_ALL_CHIPSET: (state) => {
    return state.irdetoUnpairAllChipsets
  },
  IRDETO_RESET_PIN: (state) => {
    return state.irdetoResetPIN
  },
  IRDETO_SYNCHRONIZE: (state) => {
    return state.irdetoSynchronize
  }
}

var mutations = {
  SET_IRDETO_ACTIVATE: (state, payload) => {
    state.irdetoActivate = payload
  },
  SET_IRDETO_DEACTIVATE: (state, payload) => {
    state.irdetoDeactivate = payload
  },
  SET_IRDETO_PAIR_CHIPSET: (state, payload) => {
    state.irdetoPairchipset = payload
  },
  SET_IRDETO_UNPAIR_ALL_CHIPSET: (state, payload) => {
    state.irdetoUnpairAllChipsets = payload
  },
  SET_IRDETO_RESET_PIN: (state, payload) => {
    state.irdetoResetPIN = payload
  },
  SET_IRDETO_SYNCHRONIZE: (state, payload) => {
    state.irdetoSynchronize = payload
  }
}

var actions = {
  GET_IRDETO_ACTIVATE: async (context, payload) => {
    let result = await axiosInstance.get('/users/irdeto/activate?card_number=' + payload)
    if (result.status === 200) {
      context.commit('SET_IRDETO_ACTIVATE', result.data)
    }
  },
  GET_IRDETO_DEACTIVATE: async (context, payload) => {
    let result = await axiosInstance.get('/users/irdeto/deactivate?card_number=' + payload)
    if (result.status === 200) {
      context.commit('SET_IRDETO_DEACTIVATE', result.data)
    }
  },
  GET_IRDETO_PAIR_CHIPSET: async (context, payload) => {
    let result = await axiosInstance.get('/users/irdeto/pair_chipset?card_number=' + payload.irdeto_access_card_number + '&stb_number=' + payload.irdeto_stb_serial_number)
    if (result.status === 200) {
      context.commit('SET_IRDETO_PAIR_CHIPSET', result.data)
    }
  },
  GET_IRDETO_UNPAIR_ALL_CHIPSET: async (context, payload) => {
    let result = await axiosInstance.get('/users/irdeto/unpair_all_chipsets?card_number=' + payload)
    if (result.status === 200) {
      context.commit('SET_IRDETO_UNPAIR_ALL_CHIPSET', result.data)
    }
  },
  GET_IRDETO_RESET_PIN: async (context, payload) => {
    let result = await axiosInstance.get('/users/irdeto/overwrite_parental_pin_code?card_number=' + payload)
    if (result.status === 200) {
      context.commit('SET_IRDETO_RESET_PIN', result.data)
    }
  },
  GET_IRDETO_SYNCHRONIZE: async (context, payload) => {
    let result = await axiosInstance.get('/users/irdeto/overwrite_synchronize?card_number=' + payload)
    if (result.status === 200) {
      context.commit('SET_IRDETO_SYNCHRONIZE', result.data)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/users/irdeto.js